// @styles
import globals, { dimensions } from '../../../../styles/globals';

export default (theme) => ({
    ...globals(theme),
    mainMenu: {
    },
    menuPaper: {
        backgroundColor: theme.palette.background.default,
        backgroundSize: 'cover',
        borderRight: '1.5px solid rgba(64, 64, 64, 0.3)',
        transition: theme.transitions.create(['margin', 'width'], {
            duration: theme.transitions.duration.enteringScreen,
            easing: theme.transitions.easing.easeOut
        }),
        width: dimensions.MAIN_MENU_WIDTH,
        position: 'absolute',
        minHeight:'600px',
        marginTop:'-10px'        
    },
    menuPaperCollapsed: {
        backgroundSize: 'cover',
        transition: theme.transitions.create(['margin', 'width'], {
            duration: theme.transitions.duration.leavingScreen,
            easing: theme.transitions.easing.sharp
        }),
        width: dimensions.MAIN_MENU_COLLAPSED_WIDTH,
        position: 'absolute',
        minHeight:'600px'
    },
    menuItem: {
        color: theme.palette.text.title,
        marginTop: 4,
        marginBottom: 8,
        paddingLeft: 24,
        paddingRight: 16,
        transition: theme.transitions.create(['border-color', 'background'], {
            duration: theme.transitions.duration.leavingScreen,
            easing: theme.transitions.easing.sharp
        }),
        '&:hover span': {
            color: theme.palette.primary.main
        },
        '&:hover': {
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.background.default
        },
        '&.MuiListItem-root.Mui-selected': {
            backgroundColor: 'rgba(62,130,247,.1)',
            borderRight: `3px solid ${theme.palette.primary.main}`,
            '& span': {
                color: theme.palette.primary.main
            },
            '& .MuiTypography-body1': {
                color: theme.palette.primary.main
            }
        },
        '& .MuiTypography-body1': {
            fontSize: '.875rem',
            fontWeight: '500'
        }
    },
    menuIcon: {
    },
    submenuItem: {
        height: 35,
        paddingLeft: theme.spacing(4)
    }
});
